var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicIcecream = function SvgMicIcecream(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2065_7475)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2065_7475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.617 11.623q.128-.178.236-.364a3.883 3.883 0 0 0-1.423-5.29 3.876 3.876 0 0 0-5.287 1.416c-.072.125-.145.25-.197.386a1.79 1.79 0 0 0-1.468.9 1.82 1.82 0 0 0 .145 2.015l-1.512 8.276v.061a.73.73 0 0 0 1.185.684l.013.008 4.358-3.7a1.64 1.64 0 0 0 1.73-.792l.56-.968c.669.027 1.289-.318 1.624-.897a1.79 1.79 0 0 0 .045-1.721zm-4.615 1.164-.456.79c-.346.6-.281 1.339.16 1.866l-3.402 2.882 1.262-6.945zm.887-.7-3.226-1.863a.754.754 0 0 1 .458-1.403l1.647.95a.526.526 0 0 0 .524-.908l-1.336-.772a2.79 2.79 0 0 1 1.685-1.46 2.85 2.85 0 0 1 2.275.243 2.833 2.833 0 0 1 .668 4.363l-.324.348.312.357c.22.241.254.594.09.877a.764.764 0 0 1-.852.35l-.392-.111-.942 1.633a.594.594 0 0 1-1.028-.593l.666-1.153a.62.62 0 0 0-.229-.851z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2065_7475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.196.036 25 9.16l-9.124 15.804L.072 15.84z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2065_7475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.387 3.634 8.093 4.672-7.965 13.796-8.093-4.672z"
  })))));
};
export default SvgMicIcecream;